"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("pageIframe").config(config);

  function config($stateProvider) {
    $stateProvider.state("pageIframe", {
      url: "/pageIframe/:page",
      params: {
        page: null // paramètre optionnel si nécessaire
      },
      templateUrl: "app/pages/pageIframe/pageIframe.html",
      controller: "pageIframeCtrl",
      controllerAs: "vm",
      resolve: {
        ready: function ready($q, $rootScope) {
          var deferred = $q.defer();
          if ($rootScope.$user) {
            deferred.resolve("");
          } else {
            $rootScope.$watch(function () {
              return $rootScope.$user;
            }, function () {
              if ($rootScope.$user) {
                deferred.resolve("");
              }
            }, true);
          }
          return deferred.promise;
        }
      }
    });
  }
})();